module.exports = __webpack_public_path__ + "static/media/bg.6fecd7cd.jpg";